import { ItemType } from 'antd/lib/menu/hooks/useItems';

const menuDivider: ItemType = {
    type: 'divider',
};

export default menuDivider;
